const crispWebsiteId = "22556724-7202-4112-9e41-d7f8607888d4"

const crispScriptUrl = "https://client.crisp.chat/l.js"

interface CrispQueue {
  push: (command: unknown[]) => void
}

declare global {
  interface Window {
    $crisp?: CrispQueue
    CRISP_WEBSITE_ID?: string
  }
}

export const initSupportChat = (environment: string) => {
  if (typeof document === "undefined") return
  if (environment === "local") return
  if (window.$crisp) return

  window.$crisp = [] as unknown as CrispQueue
  window.CRISP_WEBSITE_ID = crispWebsiteId

  const loader = document.createElement("script")
  loader.src = crispScriptUrl
  loader.async = true
  document.head.appendChild(loader)

  hideWhileModalOpen()
}

/**
 * The bubble sits bottom right, which is where a sheet or dialog keeps its
 * main button ("Share now", "Send message"). While a modal is open the
 * bubble steps aside. Radix marks the body with data-scroll-locked for as
 * long as a modal holds the page.
 */
const hideWhileModalOpen = () => {
  let hidden = false
  const sync = () => {
    const modalOpen = document.body.hasAttribute("data-scroll-locked")
    if (modalOpen === hidden) return
    hidden = modalOpen
    window.$crisp?.push(["do", modalOpen ? "chat:hide" : "chat:show"])
  }
  new MutationObserver(sync).observe(document.body, {
    attributes: true,
    attributeFilter: ["data-scroll-locked"],
  })
}

export const identifySupportUser = (user: {
  email?: string
  name?: string
  organizationId?: string
  organizationName?: string
}) => {
  const crisp = window.$crisp
  if (!crisp) return

  if (user.email) crisp.push(["set", "user:email", [user.email]])
  if (user.name) crisp.push(["set", "user:nickname", [user.name]])
  if (user.organizationName) {
    crisp.push(["set", "user:company", [user.organizationName]])
  }

  // Session data is what the support agent sees beside the conversation.
  // Sent as one command: Crisp replaces the whole set on each call.
  const data: string[][] = []
  if (user.organizationId) data.push(["organization_id", user.organizationId])
  if (data.length > 0) crisp.push(["set", "session:data", [data]])
}

export const resetSupportChat = () => {
  window.$crisp?.push(["do", "session:reset"])
}
